import { useRef } from "react";

function useDebounce(func, delay) {
  const idRef = useRef(null);

  const debounce = (value) => {
    if (idRef.current) {
      clearTimeout(idRef.current);
    }
    idRef.current = setTimeout(() => {
      func(value);
    }, delay);
  };

  return debounce;
}

export default useDebounce;
